import { Rv }        from '../../components'
import { SKILL_COLS } from '../../constants/data'
import { SkillBar }   from './SkillBar'

export function SkillsSection() {
  return (
    <section id="skills" className="sec">
      <div className="wrap">
        <Rv className="sh"><div className="slb">Skills</div><h2 className="st">Tools & Technologies</h2><div className="gbar"/><p className="ss">Strength in reliable automation and thoughtful test design.</p></Rv>
        <div className="skg">
          {SKILL_COLS.map((col, ci) => (
            <Rv key={col.title} delay={ci * 0.18} className="gls skc">
              <h3>{col.title}</h3>
              {col.items.map(([n, p]) => <SkillBar key={n} name={n} pct={p}/>)}
            </Rv>
          ))}
        </div>
      </div>
    </section>
  )
}
